import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import RootLayout from "./layouts/RootLayout";
import Landing from "./pages/landing";
import BackToTop from "./components/BackToTop";
import ShowNavbar from "./components/navbar/ShowNavbar";

const App = () => {
  const router = createBrowserRouter([
    {
      path: "/",
      element: <RootLayout />,
      children: [{ index: true, element: <Landing /> }],
    },
  ]);
  return (
    <div className="relative">
      <RouterProvider router={router} />
      <BackToTop />
    </div>
  );
};

export default App;
